const searchTempl = require('sma.admin/components/partials/element_search.mustache');

const STRINGS = {
	search_questions: gettext('Search your questions...'),
};

class ElementSearch {
	constructor(options) {
		this.container = options.container;
		this.showAllOnEmpty = options.showAllOnEmpty;
		this.render();
	}

	render() {
		this.searchForm = $(searchTempl({ strings: STRINGS }));
		this.searchForm.insertBefore(this.container);

		this.input = this.searchForm.find('input[type="search"]');
		this.input.bind('keyup', e => {
			if (this.input.val()) {
				this.searchForm.find('.sma-js-search-clear').show();
			} else {
				this.searchForm.find('.sma-js-search-clear').hide();
			}
			this.search();
		});
		this.clearSearchButton = this.searchForm.find('.sma-js-search-clear');
		this.clearSearchButton.click(e => {
			this.clearSearch();
		});
		if (this.showAllOnEmpty) {
			this.showAllResults();
		} else {
			this.hideAllResults();
		}
	}

	search() {
		let that = this;
		let query = this.input.val();

		this.clearCollapseOverride();
		if (query.length === 0 && this.showAllOnEmpty) {
			this.showAllResults();
			return;
		}
		this.hideAllResults();
		let searchElements = this.searchElements;
		let results = [];

		for (let el of searchElements) {
			let $el = $(el);
			let text = this.getTextIncludingParents($el);
			text = $el.text();

			let containsQuery = text.toLowerCase().includes(query.toLowerCase());

			if (containsQuery) this.showElementAndParents($el);
		}
	}

	get searchElements() {
		return this.container.children("[id!='sma-js-search-form']").toArray();
	}

	getTextIncludingParents($el) {
		let text = $el.text();

		while ($el.data('parent')) {
			let $parentEl = $(`[field-type="${$el.data('parent')}"`);
			text = $parentEl.text() + ' ' + text;
			$el = $parentEl;
		}
		return text;
	}

	showElementAndParents($el) {
		$el.show();
		$el.addClass('sma-override-collapse');

		while ($el.data('parent')) {
			let $parentEl = $(`[field-type="${$el.data('parent')}"`);
			$parentEl.show();
			$parentEl.find('.sma-guidestar-tree-expander').hide();
			$el = $parentEl;
		}
	}

	clearCollapseOverride() {
		$.each(this.searchElements, (idx, el) => {
			$(el).removeClass('sma-override-collapse');
		});
	}

	hideAllResults() {
		$.each(this.searchElements, (idx, el) => {
			$(el).hide();
		});
	}

	showAllResults() {
		$.each(this.searchElements, (idx, el) => {
			$(el).show();
		});

		$('.sma-guidestar-tree-expander').each((i, el) => {
			$(el).show();
		});
	}

	clearSearch() {
		this.input.val('');
		this.clearSearchButton.hide();
		this.clearCollapseOverride();
		if (this.showAllOnEmpty) {
			this.showAllResults();
		} else {
			this.hideAllResults();
		}
	}

	getBigrams(string) {
		const s = string.toLowerCase();
		const v = new Array(s.length - 1);
		for (let i = 0, end = v.length; i <= end; i++) {
			v[i] = s.slice(i, i + 2);
		}
		return v;
	}
}

module.exports = ElementSearch;



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.admin/components/element_search.js